<template>
  <div :class="{ 'goods-disabled-card': disabled }">
    <!-- 第一部分：头图+名称+规格+标签+已售 -->
    <div class="flex-start-start">
      <!-- 头图 -->
      <img
        class="good-img"
        v-if="haveImg"
        :src="getValue(courseInfo, 'pic_url[0]', '')"
        alt=""
      />
      <!-- 名称+规格+标签+已售 -->
      <div :class="['goods-info', haveImg ? 'info-have-img' : 'info-no-img']">
        <div class="goods-info-top">
          <div
            class="title"
            v-html="setXesFont(getValue(courseInfo, 'name', ''))"
          ></div>
          <div v-if="courseInfo.specs" class="desc">
            {{ getValue(courseInfo, "specs", "") }}
          </div>
          <div
            v-if="getValue(courseInfo, 'goodLabels', []).length"
            class="labels"
          >
            <div
              v-for="item in courseInfo.goodLabels"
              v-bind:key="item"
              class="label"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <div class="sold-num-container" v-if="courseInfo.sold_num">
          <div class="sold-num">
            已售{{ getValue(courseInfo, "sold_num", "") }}
          </div>
        </div>
      </div>
    </div>
    <!-- 第二部分：服务+赠品 -->
    <div
      v-if="courseInfo.service_desc || giftsName"
      :class="[
        'goods-service',
        haveImg ? 'service-have-img' : 'service-no-img',
      ]"
    >
      <div v-if="courseInfo.service_desc" class="service-item">
        <div class="service-item-title">服务</div>
        <div class="service-item-content">
          {{ getValue(courseInfo, "service_desc", "") }}
        </div>
      </div>
      <div v-if="giftsName" @click.stop="() => {}">
        <van-divider v-if="courseInfo.service_desc" dashed />
        <div class="service-item gifts" @click.stop="openGiftsPopup">
          <div class="service-item-title">赠品</div>
          <div class="service-item-content">{{ giftsName }}</div>
          <img
            class="arrow"
            src="https://editor.xesimg.com/tailor/resource/arrow-1753953907001.png"
          />
        </div>
        <giftsPopup
          ref="giftsPopup"
          :giftInfo="getValue(courseInfo, 'conpack_list', [])"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { get } from "lodash";
import giftsPopup from "./giftsPopup.vue";
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    courseInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    giftsPopup,
  },
  computed: {
    haveImg() {
      return this.getValue(this.courseInfo, "pic_url[0]", "");
    },
    productItem() {
      return this.getValue(this.courseInfo, "product_list[0]", {});
    },
    giftsName() {
      return this.getValue(this.courseInfo, "conpack_list", [])
        .map((item) => item.name)
        .join("·");
    },
  },
  data() {
    return {};
  },
  methods: {
    getValue(obj = {}, path, defaultVal = {}) {
      return get(obj, path, defaultVal);
    },
    setXesFont(str) {
      if (!str) return "";
      // 正则获取str所有的\【\】
      const reg = /[【|】]/g;
      // 替换reg为span标签
      return str.replace(
        reg,
        (item) => `<span class="xes-font">${item}</span>`
      );
    },
    openGiftsPopup(e) {
      this.$refs.giftsPopup.open();
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/layout.less";
.good-img {
  width: 86px;
  height: 86px;
  flex-shrink: 0;
  border-radius: 12px;
  margin-right: 8px;
  object-fit: cover;
}
.goods-info {
  .column-between-start;
  width: calc(100% - 86px);
  .goods-info-top {
    width: 100%;
  }
  .title {
    .ellipsis-two;
    color: #333;
    font-family: "PingFang SC";
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    word-break: break-all;
  }
  .desc {
    .ellipsis-one;
    width: 100%;
    margin-top: 4px;
    color: #666;
    font-family: "PingFang SC";
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
  }
  .labels {
    display: flex;
    margin-top: 4px;
    overflow: hidden;
    .label {
      margin-right: 8px;
      color: #ff8e00;
      font-family: "PingFang SC";
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
      white-space: nowrap;
      line-height: 18px;
    }
  }
  .sold-num {
    color: #666;
    font-family: "PingFang SC";
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    line-height: 18px;
  }
  .sold-num-container {
    width: 100%;
    margin-top: 4px;
    .flex-between-center;
  }
}
.info-have-img {
  width: calc(100% - 86px);
}
.info-no-img {
  width: 100%;
  padding: 8px;
  border-radius: 12px;
  background: linear-gradient(
    270deg,
    rgba(255, 255, 255, 0.6) -16.09%,
    rgba(247, 247, 248, 0.6) 83.91%
  );
}
/deep/ .van-divider {
  margin: 8px 0;
  padding-left: 30px;
}
.goods-service {
  border-radius: 12px;
  padding: 8px 0 8px 8px;
  background: linear-gradient(
    270deg,
    rgba(255, 255, 255, 0.6) -16.09%,
    rgba(247, 247, 248, 0.6) 83.91%
  );
}
.service-have-img {
  margin-top: 8px;
}
.service-no-img {
  margin-top: 4px;
}
.service-item {
  .flex-start-start;
  .service-item-title {
    color: #333;
    font-family: "PingFang SC";
    font-size: 13px;
    font-weight: 500;
    margin-right: 8px;
  }
  .service-item-content {
    flex: 1;
    color: #999;
    font-family: "PingFang SC";
    font-size: 13px;
    font-weight: 400;
    word-break: break-all;
    .ellipsis-two;
  }
  .arrow {
    width: 12px;
    height: 12px;
  }
}
.gifts {
  .flex-center-start;
  .service-item-content {
    .ellipsis-one;
    margin-right: 12px;
  }
}
.goods-disabled-card {
  .good-img,
  .arrow,
  .label {
    opacity: 0.6;
  }

  .title,
  .desc,
  .sold-num,
  .service-item-title,
  .service-item-content {
    color: #adadad;
  }
}
</style>
